import React from "react";
import type { SVGProps } from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsXls = React.forwardRef((props: SvgIconProps, ref: any) => {
    return (
        <SvgIcon {...props} ref={ref}>
        <g fill="currentColor">
        <path d="M16.7.5H4.1v12.5h-1.7v6.6l1.7,1.7v2.3h17.4V5.3L16.7.5ZM17.1,2.2l2.7,2.7h-2.7s0-2.7,0-2.7ZM3.2,18.8v-5.1h15.9v5.1H3.2ZM20.8,22.8H4.9v-3.3h14.9v-6.6H4.9V1.2h11.5v4.5h4.5v17.1Z"/>
  <path d="M10.2,14.4h-.9l-.3.6c0,.2-.2.4-.2.6h0c0-.2-.2-.4-.3-.6l-.3-.6h-.9l1,1.7-1,1.8h.9l.3-.6c.1-.2.2-.4.3-.6h0c0,.2.2.4.3.6l.3.6h.9l-1.1-1.8,1-1.7Z"/>
  <polygon points="11.5 14.4 10.7 14.4 10.7 18 12.9 18 12.9 17.3 11.5 17.3 11.5 14.4"/>
  <path d="M14.8,15.9c-.5-.2-.7-.3-.7-.5s.2-.3.5-.3.6,0,.7.2l.2-.6c-.2,0-.5-.2-.9-.2-.8,0-1.3.5-1.3,1.1s.4.8,1,1c.4.2.6.3.6.5s-.2.4-.6.4-.7-.1-.9-.2l-.2.7c.2.1.6.2,1,.2,1,0,1.4-.5,1.4-1.1s-.3-.8-.9-1.1Z"/>
        </g>
      </SvgIcon>
    );
});

export default AppIconsXls;
